import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function HotGossipScroll() {
  return (
    <section className="bg-primary-900 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block border border-accent-500/40 text-accent-400 text-xs px-3 py-1 rounded-full mb-4">
              实时热瓜
            </span>
            <h2 className="text-3xl md:text-5xl font-heading text-background-50 font-black leading-tight">
              最新热门爆料
            </h2>
          </div>
          <Link
            to="/category/mingxing-tafang"
            className="text-background-50/60 text-sm hover:text-accent-400 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Horizontal scroll cards */}
        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-0 md:-mx-0 scrollbar-hide">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer"
            >
              <div className="bg-background-100 rounded-lg overflow-hidden">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-950 leading-snug line-clamp-2 mb-2 group-hover:text-accent-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <div className="flex items-center gap-2">
                      <img
                        src={article.authorAvatar}
                        alt={article.author}
                        className="w-4 h-4 rounded-full object-cover"
                      />
                      <span>{article.author}</span>
                    </div>
                    <span>{article.date}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}